export default __webpack_public_path__ + "static/media/wind-energy.9b010c1d.svg";